<template>
  <div class="mt-3">
    <div class="row">
      <div class="col">
        <ul v-html="$t('ct-s-checkout-gateway-mercadopago-info')" class=""></ul>
      </div>
      <div class="col">
        <!-- Input Description -->
        <div class="form-group">
          <label for="name" class="control-label">{{ $t('ct-name') }}</label>
          <div class="" :class="{'has-error': e.has('name')}">
            <input type="text" class="form-control" @input="e.remove('name')" id="name" name="name"
                   v-model="config.name">
            <span class="label label-danger" v-if="e.has('name')">{{ e.first('name') }}</span>
          </div>
        </div>

        <!-- Input Client_id -->
        <div class="form-group">
          <label for="access_token" class="control-label">{{ $t('ct-access-token') }}</label>
          <div class="" :class="{'has-error': e.has('access_token')}">
            <input type="text" class="form-control" id="access_token" name="access_token"
                   @input="e.remove('access_token'), e.remove('keys')" v-model="config.access_token">
            <span class="label label-danger" v-if="e.has('access_token')">{{ e.first('access_token') }}</span>
            <span class="label label-danger" v-if="e.has('keys')">{{ e.first('keys') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- Form Submit -->
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <button class="btn btn-default" @click="$emit('cancel')">{{ $t('ct-cancel') }}</button>
          <button type="button" class="btn btn-info" @click="save">{{ $t('ct-save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MercadopagoConfig',
  props: ['value', 'e'],

  data() {
    return {
      config: this.value || {}
    };
  },

  watch: {
    config: {
      handler(config) {
        this.$emit('input', config);
      },
      deep: true
    },
    'value': function(val) {
      this.$emit('input', this.config);
    }
  },

  methods: {
    save() {
      this.e.clear();
      this.e.addValidation({
        name: 'required',
        access_token: 'required'
      });

      this.e.validate(this.config);

      if (!this.e.any()) this.$emit('save', this.config);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/GatewayConfig/MercadopagoConfig.vue